module.exports = __webpack_public_path__ + "img/power_setting.9d416337.svg";